import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  configurationError: {
    id: 'studio.Po74DG',
    defaultMessage: 'This is probably due to a configuration error in the SAML identity provider.',
  },
});
